"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Twitter;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function Twitter(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 21 18",
        width: "21",
        height: "18",
        fill: "currentColor"
    }, props);
    return /*#__PURE__*/ _react.default.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.default.createElement("path", {
        d: "M6.79 17.251C14.337 17.251 18.465 10.998 18.465 5.576C18.465 5.398 18.465 5.221 18.453 5.046C19.2562 4.46453 19.9493 3.74461 20.5 2.92C19.7511 3.252 18.9566 3.46976 18.143 3.566C18.9996 3.05306 19.6408 2.24635 19.947 1.296C19.1417 1.77389 18.2607 2.11073 17.342 2.292C16.7234 1.63377 15.905 1.19784 15.0136 1.05171C14.1222 0.905576 13.2075 1.0574 12.4111 1.48367C11.6147 1.90994 10.9811 2.58687 10.6083 3.40966C10.2355 4.23245 10.1444 5.15518 10.349 6.035C8.71759 5.95324 7.1216 5.52933 5.66465 4.79077C4.20769 4.05221 2.92233 3.01552 1.892 1.748C1.36732 2.6512 1.20659 3.72042 1.44254 4.73796C1.67848 5.75551 2.29337 6.64488 3.162 7.225C2.50926 7.20607 1.87065 7.03046 1.3 6.713V6.765C1.30039 7.7123 1.6284 8.6303 2.2284 9.36336C2.8284 10.0964 3.66347 10.5994 4.592 10.787C3.98781 10.9517 3.35389 10.9757 2.739 10.857C3.00116 11.6725 3.51168 12.3856 4.19913 12.8966C4.88658 13.4076 5.71657 13.691 6.573 13.707C5.72212 14.3756 4.74779 14.8698 3.70573 15.1615C2.66367 15.4532 1.57432 15.5366 0.5 15.407C2.3766 16.6113 4.56019 17.2501 6.79 17.247"
    }));
}

//# sourceMappingURL=Twitter.js.map